export const batpack = {
  msrp: 74.99,
  infoLink: 'https://www.teamtriton.com/batpacks.html',
  items: [
    {
      number: 'M01',
      hasModel: false,
    },
    {
      number: 'M02',
      hasModel: false,
    },
    {
      number: 'M03',
      hasModel: false,
    },
    {
      number: 'M04',
      hasModel: false,
    },
    {
      number: 'M05',
      hasModel: false,
    },
    {
      number: 'M05v2',
      hasModel: false,
    },
    {
      number: 'M06',
      hasModel: false,
    },
    {
      number: 'M06v2',
      hasModel: false,
    },
    {
      number: 'M07',
      hasModel: false,
    },
    {
      number: 'M08',
      hasModel: false,
    },
    {
      number: 'M09',
      hasModel: false,
    },
    {
      number: 'M09NVR',
      hasModel: false,
    },
    {
      number: 'M10NYS',
      hasModel: false,
    },
    {
      number: 'M11GYR',
      hasModel: false,
    },
    {
      number: 'M12GYB',
      hasModel: false,
    },
    {
      number: 'M13',
      hasModel: false,
    },
    {
      number: 'M13GRC',
      hasModel: false,
    },
    {
      number: 'M14',
      hasModel: false,
    },
    {
      number: 'M14FRC',
      hasModel: false,
    },
    {
      number: 'M15',
      hasModel: false,
    },
    {
      number: 'M15DZC',
      hasModel: false,
    },
    {
      number: 'M16GYC',
      hasModel: false,
    },
    {
      number: 'M17BLK',
      hasModel: false,
    },
    {
      number: 'M18BKC',
      hasModel: false,
    },
    {
      number: 'M19',
      hasModel: false,
    },
    {
      number: 'M019',
      hasModel: false,
    },
    {
      number: 'M020',
      hasModel: false,
    },
    {
      number: 'M25',
      hasModel: false,
    },
    {
      number: 'M26',
      hasModel: false,
    },
    {
      number: 'M27',
      hasModel: false,
    },
    {
      number: 'M29',
      hasModel: false,
    },
    {
      number: 'M30',
      hasModel: false,
    },
  ],
};
